var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileDevice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_mobile",
    "data-name": "vuesax/bulk/mobile",
    transform: "translate(-108 -380)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mobile"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.24,0H3.76C1,0,0,1,0,3.81V16.19C0,19,1,20,3.76,20h8.47C15,20,16,19,16,16.19V3.81C16,1,15,0,12.24,0Z",
    transform: "translate(112 382)",
    fill: "#292d32",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M4.75,1.5h-4A.755.755,0,0,1,0,.75.755.755,0,0,1,.75,0h4A.755.755,0,0,1,5.5.75.755.755,0,0,1,4.75,1.5Z",
    transform: "translate(117.25 384.75)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M3.5,1.75A1.75,1.75,0,1,1,1.75,0,1.75,1.75,0,0,1,3.5,1.75Z",
    transform: "translate(118.25 395.8)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(108 380)",
    fill: "none",
    opacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileDevice);
export default __webpack_public_path__ + "static/media/mobile-device.6fcdb5b8f2141acdbe72445c373a106f.svg";
export { ForwardRef as ReactComponent };